// Bilder, die erst nach dem Seitenaufbau ankommen, erscheinen sanft statt hart zu springen.
// Das erste sichtbare Bild (loading="eager") wird nie ausgeblendet, damit die Messung der
// Ladezeit (Largest Contentful Paint) unveraendert bleibt. Es bekommt nur die Platzhalterflaeche.

const NEW_IMAGES = 'img:not([data-state])';

function track(image) {
  // Schon fertig geladen, zum Beispiel aus dem Cache: nichts tun, sonst blitzt es
  if (image.complete) return;
  image.dataset.state = 'loading';
}

function scan(root) {
  if (root instanceof Element && root.matches('img')) track(root);
  if (root instanceof Element || root instanceof Document) {
    for (const image of root.querySelectorAll(NEW_IMAGES)) track(image);
  }
}

// Ein einziger Zuhoerer fuer alle Bilder: load und error steigen nicht auf,
// erreichen das Dokument aber in der Erfassungsphase.
for (const type of ['load', 'error']) {
  document.addEventListener(
    type,
    (event) => {
      const image = event.target;
      if (image instanceof HTMLImageElement && image.dataset.state === 'loading') {
        image.dataset.state = 'ready';
      }
    },
    true
  );
}

scan(document);

// Nachgeladene Inhalte wie Schnellkauf, Empfehlungen oder gewechselte Varianten
new MutationObserver((records) => {
  for (const record of records) {
    for (const node of record.addedNodes) scan(node);
  }
}).observe(document.documentElement, { childList: true, subtree: true });

// Sicherheitsnetz: was beim Seitenende schon fertig ist, wird aufgedeckt
window.addEventListener(
  'load',
  () => {
    for (const image of document.querySelectorAll('img[data-state="loading"]')) {
      if (image.complete) image.dataset.state = 'ready';
    }
  },
  { once: true }
);
